import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import Pulse from "@sopranodesign/pulse-boost";

Pulse.render();